const AccountSharingListView = () => import('@/views/SuperAdmin/AccountSharing/AccountSharingListView')
const AccountSharingUserView = () => import('@/views/SuperAdmin/AccountSharing/AccountSharingUserView')

export default [
	{
		component: AccountSharingListView,
		name: 'sa-account-sharing',
		path: 'account-sharing'
	},
	{
		component: AccountSharingUserView,
		name: 'sa-account-sharing-user',
		path: 'account-sharing/users/:userId',
		props: route => {
			return {
				userId: Number(route?.params?.userId)
			}
		}
	}
]
